import styles from './SportListItem.module.css';
import { Sport } from 'types/Sport';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { List } from 'components/List/List';
import { useNavigate } from 'react-router-dom';
import { getLeaguesForSidebar } from 'services/api/sportBetsService';
import { LeagueContext } from 'context/leagueContext';
import { sportTranslationKey } from 'helpers/sportI18n';
import { getDefaultSportIconSrc } from 'helpers/sportIcon';
import { SportIcon } from 'components/ThemeIcon/SportIcon';

interface Props {
  sport: Sport;
  time?: string | null | undefined;
  resultsMode?: boolean;
}

export const SportListItem = ({ sport, time, resultsMode = false }: Props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(false);
  const { isMobile } = useBreakpoint();
  const navigate = useNavigate();
  const [leagues, setLeagues] = useState<null | Array<any>>(null);
  const { toTime, fromTime } = useContext(LeagueContext);

  const handleSportClick = async (sport: any) => {
    if (isMobile) {
      const base = resultsMode ? '/results' : '/sports-betting';
      navigate(
        `${base}/sport/${sport.name}/${sport.id}${time ? `?time=${time}` : ''}`
      );
    } else {
      setLeagues(
        await getLeaguesForSidebar(
          sport.id,
          toTime,
          resultsMode,
          fromTime ?? undefined
        )
      );
    }
  };

  useEffect(() => {
    setLeagues([]);
    setExpanded(false);
  }, [toTime, fromTime]);

  return (
    <div
      className={styles.container}
      data-is-expanded={expanded}
      onClick={() => handleSportClick(sport)}
    >
      <div
        className={styles.wrapper}
        data-is-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        <SportIcon
          sportId={sport.id}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = getDefaultSportIconSrc();
          }}
          alt={t(sportTranslationKey(sport.id), { defaultValue: sport.name })}
          className={styles.icon}
        />
        <span className={styles.title} data-is-expanded={expanded}>
          {t(sportTranslationKey(sport.id), { defaultValue: sport.name })}
        </span>
        {!!sport.count && <div className={styles.count}>{sport.count}</div>}
      </div>

      {!isMobile && (
        <div className={styles.sportMenuWrapper} data-is-expanded={expanded}>
          {leagues && leagues.length > 0 && (
            <List items={leagues} parentId={sport.id} />
          )}
        </div>
      )}
    </div>
  );
};
